import React, { useState, useEffect, useReducer } from 'react'
import {
  Col,
  Panel,
  Row,
  IconButton,
  Icon,
  ButtonGroup,
  Message,
  CheckPicker,
  SelectPicker,
  Input,
} from 'rsuite'
import { Controller, useForm } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import SearchButton from '../../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import CheckApprovalTable from './CheckApprovalTable'
import { DEFAULT_ERR_MSG, ERR_MSG_404, RETRY_CONTACT_ADMIN } from '../../../constants/msgText'
import notification from '../../../utils/notification'
import {
  getCheckApproverList,
  getFetchNew,
  getSendMailApprover,
} from '../../../redux/actions/approveProject'
import CancelApprovalList from '../../../components/modal/ApproverListModal/CancelApprovalList'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import ApproverList from '../../../components/modal/ApproverListModal/ApproverList'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import FetchNewApprover from '../../../components/modal/ApproverListModal/FetchNewApprover'

export default function CheckApprovalWidget(props) {
  const { control, register, errors, setValue, clearErrors, handleSubmit } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isExpanded, setIsExpanded] = useState(true)
  const projectCode = sessionStorage.getItem('projectCode')
  const [_, forceUpdate] = useReducer((x) => x + 1, 0)
  const [isLoading, setIsLoading] = useState(false)
  const [contractNoValue, setContractNoValue] = useState()
  const [txtModelTypeVal, setTxtModelTypeVal] = useState(0)
  const [txtApproverCodeVal, setTxtApproverCodeVal] = useState()
  const [txtBudgetYearVal, setTxtBudgetYearVal] = useState()
  const [projectCodeVal, setProjectCodeVal] = useState()
  const [taxApproveStatusVal, setTaxApproveStatusVal] = useState(0)
  const [departmentCodeVal, setDepartmentCodeVal] = useState(0)
  const [displayLength, setDisplayLength] = useState(10)
  const [page, setPage] = useState(1)
  const [dataTable, setDataTable] = useState(props.schema.forms.result)
  const [searchRequest, setSearchRequest] = useState({
    projectCode: projectCodeVal || '',
    contractNo: contractNoValue || '',
    approveStatus: taxApproveStatusVal || 0,
    approveType: txtModelTypeVal || 0,
    approverCode: txtApproverCodeVal || '',
    budgetYear: txtBudgetYearVal || '',
    departmentCode: departmentCodeVal || '',
  })
  const [isShowConf, setIsShowConf] = useState()

  useEffect(() => {
    var year = GetBudgetYear()
    setTxtBudgetYearVal(year)
    console.log('555==>',year)
  }, [])

  const onCancel = async () => {
    var year = GetBudgetYear()

    setProjectCodeVal('')
    setTxtBudgetYearVal(year)
    setContractNoValue('')
    setTxtApproverCodeVal('')
    setTaxApproveStatusVal(null)
    setTxtModelTypeVal(null)
    setDepartmentCodeVal('')
    let request = {
      projectCode: '',
      contractNo: '',
      approveStatus: 0,
      approveType: 0,
      approverCode: '',
      budgetYear: year,
      departmentCode: ''
    }

    handleSearch(1, displayLength, request)
  }

  const onSearch = async () => {
    let request = {
      projectCode: projectCodeVal || '',
      contractNo: contractNoValue || '',
      approveStatus: taxApproveStatusVal || 0,
      approveType: txtModelTypeVal || 0,
      approverCode: txtApproverCodeVal || '',
      budgetYear: txtBudgetYearVal || '',
      departmentCode : departmentCodeVal || ''
    }

    handleSearch(1, displayLength, request)
  }
  const handleSearch = async (pagenumber, pagesize, request) => {
    setIsLoading(true)
    startLoading()
    try {
      setPage(pagenumber)
      setDisplayLength(pagesize)
      setSearchRequest(request)

      const response = await getCheckApproverList(pagesize, pagenumber, request)
      setDataTable(response.forms.result)
    } catch (e) {
      console.log('error', e)

      notification.open('error', {
        title: e?.response?.data?.errors?.message || RETRY_CONTACT_ADMIN,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onReload = (pagenumber, pagesize) => {
    handleSearch(pagenumber, pagesize, searchRequest)
  }

  const handleSelectRowData = (rowData) => {
    console.log('handleSelectRowData + rowData==>', rowData)
    let request = {
      projectVersionId: rowData.projectVersionId || '',
      mailType: rowData.mailType || null,
      approveType: rowData.approveType || '',
      requestId: rowData.requestId || null,
    }
    console.log('handleSelectRowData + request==>', request)
    handleGetSendMailApprover(request)
  }
  const handleGetSendMailApprover = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      //  console.log('request===>', request)
      const response = await getSendMailApprover(
        request.projectVersionId,
        request.mailType,
        request.approveType,
        request.requestId
      )

      if (response.success == true) {
        notification.open('success', {
          title: 'ส่งอีเมลสำเร็จ',
          duration: 5000,
        })
        setIsShowConf(false)
      } else {
        notification.open('error', {
          title: response.errorDesc || 'ไม่พบข้อมูลสำหรับส่งเมล',
          duration: 5000,
        })
        setIsShowConf(false)
      }
    } catch (e) {
      console.log('error', e)
      setIsShowConf(false)
      notification.open('error', {
        title: e?.response?.errorDesc || ERR_MSG_404,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }
  const GetBudgetYear = () => {
    var defaultYear = new Date().getFullYear() + 543
    if (new Date().getMonth() >= 9) {
      defaultYear = new Date().getFullYear() + 543 + 1 //ปีงบประมาณ = ปีปัจุบัน+1 (เดือน 10 11 12)
    }
    return defaultYear
  }

  return (
    <>
      <Panel
        shaded
        // collapsible
        defaultExpanded
        bordered
        //header={'รายงานการยื่นแบบและชำระภาษีออนไลน์ (e-Filing)'}
        expanded={isExpanded}
        onSelect={() => {
          setIsExpanded(!isExpanded)
          setTimeout(() => {
            forceUpdate()
          }, 100)
        }}
      >
        <Panel header={'ค้นหา'} collapsible defaultExpanded bordered style={{ marginBottom: 20 }}>
          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {formSchema?.forms.searchForm?.projectCode?.label}
              <Input
                value={projectCodeVal}
                onChange={(value) => {
                  setProjectCodeVal(value)
                }}
              />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {formSchema?.forms.searchForm?.contractNo?.label}
              <Input
                value={contractNoValue}
                onChange={(value) => {
                  setContractNoValue(value)
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>
          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {formSchema?.forms.searchForm?.budgetYear?.label}
              <Input
                value={txtBudgetYearVal}
                onChange={(value) => {
                  setTxtBudgetYearVal(value)
                }}
              />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {formSchema?.forms?.searchForm?.approveName?.label}
              <SelectPicker
                searchable={true}
                value={txtApproverCodeVal}
                data={formSchema?.forms?.searchForm?.approveName?.options}
                block
                onChange={(value) => {
                  setTxtApproverCodeVal(value)
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>
          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {formSchema?.forms?.searchForm?.approveStatus?.label}
              <SelectPicker
                searchable={false}
                value={taxApproveStatusVal}
                data={formSchema?.forms?.searchForm?.approveStatus?.options}
                block
                onChange={(value) => {
                  setTaxApproveStatusVal(value)
                }}
              />
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {formSchema.forms.searchForm.approveType.label}
              <SelectPicker
                searchable={false}
                value={txtModelTypeVal}
                data={formSchema.forms.searchForm.approveType.options}
                block
                onChange={(value) => {
                  setTxtModelTypeVal(value)
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>

          {formSchema?.forms?.searchForm?.department &&
          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {formSchema?.forms?.searchForm?.department?.label}
              <SelectPicker
                searchable={false}
                value={departmentCodeVal}
                data={formSchema?.forms?.searchForm?.department?.options}
                block
                onChange={(value) => {
                  setDepartmentCodeVal(value)
                }}
              />
            </Col>
          </Row>}

          <Row style={{ marginBottom: 20, marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={20} md={20} sm={24} xs={24}>
              <SearchButton
                disabled={isLoading}
                onClick={onSearch}
                style={{ marginTop: 0, marginLeft: 0 }}
              >
                ค้นหา
              </SearchButton>
              <CancelButton onClick={onCancel} style={{ marginTop: 0, marginLeft: 10 }}>
                ยกเลิก
              </CancelButton>
            </Col>
          </Row>
        </Panel>

        <CheckApprovalTable
          schema={dataTable}
          loading={isLoading}
          onReload={onReload}
          onSelect={handleSelectRowData}
          page={page}
          displayLength={displayLength}
          isShowConf={isShowConf}
          setIsShowConf={setIsShowConf}
        />
      </Panel>
    </>
  )
}
